/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/*jshint multistr: true */
/* jshint expr: true */

(function ($) {

  function removeHash() {
    var scrollV, scrollH, loc = window.location;
    if ("pushState" in history)
      history.pushState("", document.title, loc.pathname + loc.search);
    else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;

      loc.hash = "";

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  }

  function watchNavigationScroll() {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }

    if ($('#home-banner').length) {
      if ($(window).scrollTop() > $('#home-banner').outerHeight()) {
        $('body').addClass('fixed-nav');
      }
      else {
        $('body').removeClass('fixed-nav');
      }
    }

    var page_banner = $('#page-banner');

    if (page_banner.length) {
      if ($(window).scrollTop() > (page_banner.offset().top + page_banner.outerHeight())) {
        $('body').addClass('scrolled-more');
      }
      else {
        $('body').removeClass('scrolled-more');
      }
    }
  }

  function getScrollbarWidth() {
    var scrollbarSize = 0;
    var scrollDiv = document.createElement("div");
    scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
    document.body.appendChild(scrollDiv);
    scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarSize;
  }

  var bspd = function(s) {
    var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
    var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(i=0;i<64;i++){e[A.charAt(i)]=i;}
    for(x=0;x<L;x++){
        c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
        while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
    }
    return r;
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        watchNavigationScroll();
        $(window).on('load resize scroll', function () {
          watchNavigationScroll();
        });

        if ($('.sidebar').length) {
          var sidebar = new StickySidebar('.sidebar', {
            containerSelector: '.page-sections .container',
            innerWrapperSelector: '.sidebar-inner',
            topSpacing: $('body').hasClass('admin-bar') ? 100 : 70
          });

          setInterval(function() {
            sidebar.updateSticky();
          }, 2000);
        }

        $(document).on('click', '.menu-toggle', function (e) {
          e.preventDefault();

          if ($('body').hasClass('nav-on')) {
            $('body').removeClass('nav-on');
            // $('#page').css('margin-right', '0px');
          }
          else {
            $('body').addClass('nav-on');
            // $('#page').css('margin-right', getScrollbarWidth());
          }
        });

        $(document).on('click', '.search-toggle', function (e) {
          e.preventDefault();

          if ($('body').hasClass('search-on')) {
            $('body').removeClass('search-on');
            if (!$('body').hasClass('nav-on')) {
              // $('#page').css('margin-right', '0px');
            }
            $('#search-field').blur();
          }
          else {
            $('body').addClass('search-on');
            // $('#page').css('margin-right', getScrollbarWidth());
            setTimeout(function () {
              $('#search-field').focus();
            }, 500);
          }
        });

        $(document).on('submit', '#search form', function (e) {
          if (!$('#search-field').val()) {
            $('#search-field').addClass('error');
            e.preventDefault();
            return false;
          }
          else {
            $('#search-field').removeClass('error');
            $('body').removeClass('search-on');
            if (!$('body').hasClass('nav-on')) {
              $('#page').css('margin-right', '0px');
            }
          }
        });

        if ($('.articles-list').length) {
          var $blog_grid = $('.articles-list');
          if ($blog_grid.length) {
            $blog_grid.isotope({
              itemSelector: '.article',
              percentPosition: true,
              masonry: {
                columnWidth: '.grid-sizer'
              }
            });

            $blog_grid.imagesLoaded().progress(function () {
              $blog_grid.isotope('layout');
            });

            $(window).on('resize', function () {
              $blog_grid.imagesLoaded().progress(function () {
                $blog_grid.isotope('layout');
              });
            });
          }
        }

        $(document).keyup(function (e) {
          if (e.keyCode === 27) {
            if ($('body').hasClass('search-on')) {
              $('body').removeClass('search-on');
            }
            else if ($('body').hasClass('nav-on')) {
              $('body').removeClass('nav-on');
            }
          }
        });

        if ($('.intro-carousel').length) {
          $('.intro-carousel').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false
          });
        }

        if (window.location.hash) {
          var target = $(window.location.hash);

          if (target.length) {
            removeHash();

            setTimeout(function () {
              $('html,body').stop().animate({
                scrollTop: target.offset().top + 70 + ($('body').hasClass('admin-bar') ? 30 : 0)
              }, 'slow');
            }, 300);
          }
        }


        if($('.banner-text-carousel').length) {
          $('.background-images').slick({
            fade: true,
            dots: false,
            arrows: false,
            asNavFor: '.banner-text-carousel',
            pauseOnHover: false,
            pauseOnDotsHover: false,
            pauseOnFocus: false
          });

          $('.banner-text-carousel').slick({
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false,
            asNavFor: '.background-images',
            pauseOnHover: false,
            pauseOnDotsHover: false,
            pauseOnFocus: false
          });
        }

        $('.instagram-feed').each(function() {
          var t = $(this),
              user = $(this).attr('data-user');

          var feed = new Instafeed({
            get: 'user',
            userId: user,
            accessToken: bspd( js_vars.iat ),
            clientId: js_vars.icid,
            limit: 4,
            mock: true,
            success: function(response) {
              if(response && response.data) {
                t.find('.ajax-loader').remove();

                for(var i in response.data) {
                  var src = response.data[i].images.standard_resolution.url;

                  var div = $('<div class="instagram-item" style="background-image: url(\'' + src + '\')"></div>');

                  var overlay = $('<div class="item-overlay">\n\
                        <div class="left-side"><i class="fa fa-heart-o"></i> '+response.data[i].likes.count+'</div>\n\
                        <div class="right-side"><a target="_blank" href="'+response.data[i].link+'"><i class="fa fa-instagram"></i></a></div>\n\
                      </div>');

                  div.append( overlay );

                  div.appendTo( t );
                }
              }
            }
          });

          feed.run();
        });

        $('.photo-gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          closeOnContentClick: false,
          closeBtnInside: false,
          mainClass: 'mfp-with-zoom mfp-img-mobile',
          image: {
            verticalFit: true
          },
          gallery: {
            enabled: true
          },
          zoom: {
            enabled: true,
            duration: 300,
            opener: function(element) {
              return element.find('img');
            }
          }
        });

        $('.projects-gallery .project-item').each(function() {
          var t = $(this);

          t.magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
              verticalFit: true
            },
            gallery: {
              enabled: true
            },
            zoom: {
              enabled: true,
              duration: 300,
              opener: function(element) {
                return t.find('.main-photo img');
                // return element.find('img');
              }
            }
          });
        });

        $('#corporate-video').on('show.bs.modal', function (e) {
          var video = $('#corporate-video-player');

          if(!video.find('.source-mp4').attr('src')) {
            video.find('.source-mp4').attr('src', video.find('.source-mp4').attr('data-src'));
          }
        });

        $('#corporate-video').on('shown.bs.modal', function (e) {
          var video = $('#corporate-video-player');

          video.get(0).play();
        });

        $('#corporate-video').on('hide.bs.modal', function (e) {
          var video = $('#corporate-video-player');

          video.get(0).pause();
        });

        $(document).on('click', '[href="#corporate-video"]', function(e) {
          e.preventDefault();

          $('#corporate-video').modal('show');
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
